	function ContactFormPropertyManagement(settings){
		this.setup(settings);
	}
	ContactFormPropertyManagement.inheritsFrom( ContactForm );
	ContactFormPropertyManagement.prototype.instructions = function(){
		return {
			pages: [
				{ 	name: "index", 		
					questions: ['property']
				},

				{
					name: "questions",	
					questions: ['private-rooms'],
					include: (e) => {
						const property = this.values['property'];
						// const propertyType = this.values['property-type'];
						// const occupancy = this.values['occupancy'];

						//Mark as expected if other questions aren't answered yet (so count total doesn't jump)
						// if(!property) return true;

						// IF (SINGLE-PROPERTY || PORTFOLIO || PRIVATE-HOME) && (OCCUPIED || MIXED)
						return (
							(property === "private")
						);
					}
				},

				{
					name: "questions",	
					questions: ['rental-type'],
					include: (e) => {
						const property = this.values['property'];
						return (
							(property === "rental")
						);
					}
				},

				// {
				// 	name: "questions",
				// 	questions: ['vacant-type'],
				// 	include: (e) => {
				// 		const property = this.values['property'];
				// 		return (
				// 			(property === "vacant")
				// 		);
				// 	}
				// },

				// {
				// 	name: "questions",	
				// 	questions: ['private-amenities'],
				// 	include: (e) => {
				// 		const property = this.values['property'];
				// 		return (
				// 			(property === "private")
				// 		);
				// 	}
				// },

				{
					name: "questions",	
					questions: ['rental-single-rooms'],
					include: (e) => {
						const property = this.values['property'];
						const rentalType = this.values['rental-type'];
						return (
							(property === "rental")
							&&
							(rentalType === "single")
						);
					}
				},		
				
				{
					name: "questions",	
					questions: ['rental-portfolio-count'],
					include: (e) => {
						const property = this.values['property'];
						const rentalType = this.values['rental-type'];
						return (
							(property === "rental")
							&&
							(rentalType === "portfolio")
						);
					}
				},
				{ 	name: "details1",	questions: ['full-name'],
					include: (e) => {
						const property = this.values['property'];
						const bedrooms = this.values['private-rooms'];
						const portfolioCount = this.values['rental-portfolio-count'];
						const rentalRooms = this.values['rental-single-rooms'];
						//const vacantType = this.values['vacant-type'];
						return ((bedrooms != "")||(portfolioCount!="")||(rentalRooms!="")||('vacant' === property));
					}
				},
				{ 	name: "details2",	questions: ['email'],
					include: (e) => {
						const property = this.values['property'];
						const bedrooms = this.values['private-rooms'];
						const portfolioCount = this.values['rental-portfolio-count'];
						const rentalRooms = this.values['rental-single-rooms'];
						// const vacantType = this.values['vacant-type'];
						return ((bedrooms != "")||(portfolioCount!="")||(rentalRooms!="")||('vacant' === property));
					}
				},
				{ 
					name: "details3",	questions: ['phone'],
					include: (e) => {
						const property = this.values['property'];
						const bedrooms = this.values['private-rooms'];
						const portfolioCount = this.values['rental-portfolio-count'];
						const rentalRooms = this.values['rental-single-rooms'];
						// const vacantType = this.values['vacant-type'];
						return ((bedrooms != "")||(portfolioCount!="")||(rentalRooms!="")||('vacant' === property));
					}
				},
				{ 
					name: "details4",	questions: ['your-requirements'], 
					include: (e) => {
						const property = this.values['property'];
						const bedrooms = this.values['private-rooms'];
						const portfolioCount = this.values['rental-portfolio-count'];
						const rentalRooms = this.values['rental-single-rooms'];
						// const vacantType = this.values['vacant-type'];
						return ((bedrooms != "")||(portfolioCount!="")||(rentalRooms!="")||('vacant' === property));
					}
				}

			],

			questions: [
				{
					name: "property",
					input: "buttons",
					inputType: "single",
					required: true,
					labels: "What are you looking to have managed?",
					answers: [
						{ labels: "Private home", 		value: "Private home", 		name: "private" },
						{ labels: 'Rental investment', 	value: "Rental Investment", name: "rental" },
						{ labels: 'Vacant property', 	value: "Vacant property", 	name: "vacant" }
					],
				 },
				 {
				 	name: "private-where",
					input: "text",
					inputType: false,
					required: false,
					labels: "Where is the property located?",
					placeholder: "e.g Kensington and Chelsea"
				 },
				 {
					name: "private-rooms",
					input: "buttons",
					inputType: "single",
					required: false,
					labels: "How many bedrooms does the property have?",
					answers: [
						{ labels: "1 - 3",		name: "1-3" },
						{ labels: "4 - 7", 		name: "4-7" },
						{ labels: "8 - 11", 	name: "8-11" },
						{ labels: "12+", 		name: "12+" },
					],
				 },
				 {
					name: "rental-type",
					input: "buttons",
					inputType: "single",
					required: false,
					labels: "What are you looking to have managed?",
					answers: [
						{ labels: "Single Property", 	value: "Single Property", 	name: "single" },
						{ labels: 'Portfolio', 			value: "Portfolio", 		name: "portfolio" }
					],
				 },
				/*
				 {
					name: "vacant-type",
					input: "buttons",
					inputType: "single",
					required: false,
					labels: "How would you like the property to be managed?",
					answers: [
						{ labels: "Weekly inspections", 	name: "weekly-inspections"	},
						{ labels: "Full management", 		name: "full-management", 	showNextField: true },
					],
				},
				*/
				{
					name: "private-amenities",
					input: "buttons",
					inputType: "multiple",
					required: false,
					labels: "What amenities would you potentially want to be managed?",
					answers: [
						{ labels: "Water systems", 			name: "water-systems" },
						{ labels: "AC & heating", 			name: "ac-heating" },
						{ labels: "AV", 					name: "av" },
						{ labels: "Security & fire systems",name: "security-fire-systems" },
						{ labels: "Garden", 				name: "garden" },
						{ labels: "Pool", 					name: "pool" },
						{ labels: "Lift", 					name: "lift" },
						{ labels: "Spa facilities", 		name: "spa-facilities" },
						{ labels: "Household staff", 		name: "household-staff" },
						{ labels: "Other", 					name: "other" },
					],
				},
				{
				 	name: "rental-single-where",
					input: "text",
					inputType: false,
					required: false,
					labels: "Where is the property located?",
					placeholder: "e.g Kensington and Chelsea"
				},
				{
					name: "rental-single-rooms",
					input: "buttons",
					inputType: "single",
					required: false,
					labels: "How many bedrooms does the property have?",
					answers: [
						{ labels: "1 - 3",		name: "1-3" },
						{ labels: "4 - 7", 		name: "4-7" },
						{ labels: "8 - 11", 	name: "8-11" },
						{ labels: "12+", 		name: "12+" },
					],
				},
				{
					name: "rental-portfolio-count",
					input: "buttons",
					inputType: "single",
					required: false,
					labels: "How many properties are you looking to have managed?",
					answers: [
						{ labels: "2 - 3",		name: "2-3",},
						{ labels: "4 - 10", 	name: "4-10",},
						{ labels: "10 - 20", 	name: "10-20"},
						{ labels: "20+", 		name: "20+",},
					],
				},
				{
				 	name: "rental-portfolio-where",
					input: "text",
					inputType: false,
					required: false,
					labels: "Where are the properties located?",
					placeholder: "e.g Kensington and Chelsea"
				},
				{
					name: "full-name",
					input: "text",
					required: true,
					labels: "Please tell us your name",
					placeholder: "Type your name here",
				},{
					name: "email",
					input: "text",
					required: false,
					labels: "Please enter your email address",
					placeholder: "Type your email address",
				},{
					name: "phone",
					input: "text",
					required: false,
					labels: "Please enter your phone number",
					placeholder: "Type your phone number",
				},
				{
					name: "your-requirements",
					input: "textarea",
					required: false,
					labels: "Further information you would like to share",
					placeholder: "Type further information here",
				}

				
			]
		}
	}
